import { useSecondaryMenu } from 'ui/components/BPLayout'

export const TemplatesSideBar = ({ historyEnabled = false }: { historyEnabled?: boolean }) => {
  useSecondaryMenu([
    { label: 'Template Details', hash: 'details' },
    ...(historyEnabled ? [{ label: 'History', hash: 'history' }] : [])
  ])

  return null
}
